import { BrainCircuit } from "lucide-react";

const THINKING_PROVIDERS = new Set(["deepseek", "moonshot"]);
const FIXED = new Set(["kimi-k2.7-code"]);

export const supportsThinking = (provider, model) => THINKING_PROVIDERS.has(provider) && !FIXED.has(model);

export const ThinkingToggle = ({ provider, model, enabled, onChange, disabled, size = "md" }) => {
  if (!supportsThinking(provider, model)) return null;
  const sm = size === "sm";
  return (
    <button
      type="button"
      onClick={() => onChange(!enabled)}
      disabled={disabled}
      data-testid="thinking-toggle"
      aria-pressed={enabled}
      title={enabled ? "Deep thinking on — slower, more thorough" : "Deep thinking off — fast answers"}
      className={`inline-flex items-center gap-1.5 rounded-xl border font-medium transition-colors disabled:opacity-60 ${sm ? "px-2.5 py-1.5 text-xs" : "px-3 py-1.5 text-sm"} ${
        enabled ? "bg-fuchsia-500/15 text-fuchsia-200 border-fuchsia-500/50 shadow-[0_0_16px_rgba(217,70,239,0.25)]" : "bg-[#11131E] text-slate-400 border-slate-800 hover:text-white hover:border-slate-600"
      }`}
    >
      <BrainCircuit className={`${sm ? "w-3.5 h-3.5" : "w-4 h-4"} ${enabled ? "animate-pulse" : ""}`} />
      {enabled ? "Thinking" : "Think"}
    </button>
  );
};
